import { todoFeedsQueryDocument } from 'api/todo-feeds';
import { useGraphQLWithOptions } from './useGraphQL';

export function useTodoFeedsQuery() {
  return useGraphQLWithOptions(todoFeedsQueryDocument, {
    cacheTime: 0,
  });
}
